import React from "react";
import {ToolSatis1} from "../../tool/satis/1/index";

export default function FacilityRootOverview() {
    return <ToolSatis1 />;
}
